export class Common {

    static element(id) {
        return document.getElementById(id);
    }

    static hide(id) {
        Common.element(id).style.display = 'none';
    }

    static show(id) {
        Common.element(id).style.display = 'block';
    }

    static get_bounds(id) {
        return Common.element(id).getBoundingClientRect();
    }

    static slugify(text) {
        return text
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^\w-]+/g, '')
            .replace(/--+/g, '-')
    }

    static deepCopy(inObject) {
        let outObject, value, key
        if (typeof inObject !== "object" || inObject === null) {
            return inObject // Return the value if inObject is not an object
        }
        // Create an array or object to hold the values
        outObject = Array.isArray(inObject) ? [] : {}
        for (key in inObject) {
            value = inObject[key]
            if (key === 'ref') {
                outObject[key] = value;
                continue;
            }
            // Recursively (deep) copy for nested objects, including arrays
            outObject[key] = this.deepCopy(value)
        }
        return outObject
    }

    static format_date () {
        const d = new Date();
        const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
        const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
        const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
        const hour = new Intl.DateTimeFormat('en', { hour: 'numeric' }).format(d);
        const minute = new Intl.DateTimeFormat('en', { minute: '2-digit' }).format(d);
        const second = new Intl.DateTimeFormat('en', { second: '2-digit' }).format(d);
        return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
    }
}

export default Common;